<template>
  <div class="statistics">
    <div class="df statistics-box">
      <div v-for="(item, index) in summaps" :key="index" class="df-c">
        <div class="left">
          <div class="title">{{ item.title }}</div>
          <div class="digital-flopa df">
            <div class="pcspre">{{ item.pcspretxt }}</div>
            <div class="pri">{{ Number(item.pcs).toLocaleString() }}</div>
            <div
              class="unit"
              :class="(item.pcsunite == '%' || item.pcsunite == 'H')?'unit-en':''"
            >{{ item.pcsunite }}</div>
            <!-- pcsadd=1显示上升箭头 -1显示下降箭头 -->
            <div class="trend">
              <img v-if="item.pcsadd==1" src="@/assets/images/bigscreenSales/up.png" alt srcset />
              <img v-if="item.pcsadd==-1" src="@/assets/images/bigscreenSales/down.png" alt srcset />
            </div>
          </div>
          <div class="digital-flopa df">
            <div class="pcspre">{{ item.pripretxt }}</div>
            <div class="pri">{{ Number(item.sumpri).toLocaleString() }}</div>
            <div
              class="unit"
              :class="(item.priunite == '%' || item.priunite == 'H')?'unit-en':''"
            >{{ item.priunite }}</div>
            <div class="trend">
              <img v-if="item.priadd==1" src="@/assets/images/bigscreenSales/up.png" alt srcset />
              <img v-if="item.priadd==-1" src="@/assets/images/bigscreenSales/down.png" alt srcset />
            </div>
          </div>
        </div>
        <div class="right">
          <img src="@/assets/images/bigscreenSales/statistics_line.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/js/config'
export default {
  name: 'Statistics',
  created () {
    this.requestUrl=window.localStorage.getItem('requestUrl')
    this.getsumaa()
  },
  data () {
    return {
      summaps: [
        {
          title: '月初留存',
          pcs: 0,
          sumpri: 0,
          pcsunite: '件',
          priunite: '万元',
          pcsuniteWidth: '30px',
          pcspretxt: '',
          pripretxt: '',
          pcsadd: 0,
          priadd: 0
        },
        {
          title: '本月接单统计',
          pcs: 0,
          sumpri: 0,
          pcsunite: '件',
          priunite: '万元',
          pcsuniteWidth: '30px',
          pcspretxt: '',
          pripretxt: '',
          pcsadd: 0,
          priadd: 0
        },
        {
          title: '加工中工件',
          pcs: 0,
          sumpri: 0,
          pcsunite: '件',
          priunite: '万元',
          pcsuniteWidth: '30px',
          pcspretxt: '',
          pripretxt: '',
          pcsadd: 0,
          priadd: 0
        },
        {
          title: '本月出货统计',
          pcs: 0,
          sumpri: 0,
          pcsunite: '件',
          priunite: '万元',
          pcsuniteWidth: '30px',
          pcspretxt: '',
          pripretxt: '',
          pcsadd: 0,
          priadd: 0
        },
        {
          title: '出货达成率',
          pcs: 0,
          sumpri: 0,
          pcsunite: '%',
          priunite: '%',
          pcsuniteWidth: '24px',
          pcspretxt: '数量别',
          pripretxt: '金额别',
          pcsadd: 0,
          priadd: 0
        },
        {
          title: '本月采购发出',
          pcs: 0,
          sumpri: 0,
          pcsunite: '件',
          priunite: '万元',
          pcsuniteWidth: '30px',
          pcspretxt: '',
          pripretxt: '',
          pcsadd: 0,
          priadd: 0
        },
        {
          title: '采购回厂统计',
          pcs: 0,
          sumpri: 0,
          pcsunite: '件',
          pcsuniteWidth: '30px',
          priunite: '万元',
          pcspretxt: '',
          pripretxt: '',
          pcsadd: 0,
          priadd: 0
        },
        {
          title: '采购达成率',
          pcs: 0,
          sumpri: 0,
          pcsunite: '%',
          priunite: '%',
          pcsuniteWidth: '24px',
          pcspretxt: '交货达成率',
          pripretxt: '金额达成率',
          pcsadd: 0,
          priadd: 0
        },
        {
          title: '工时状态',
          pcs: 0,
          sumpri: 0,
          pcsunite: 'H',
          priunite: 'H',
          pcsuniteWidth: '24px',
          pcspretxt: '新增',
          pripretxt: '完成',
          pcsadd: 0,
          priadd: 0
        }
      ],
      compid: -1,
      dept: '',
      requestTimer: null,
      requestUrl:''
    }
  },
  methods: {
    getsumaa () {
      this.dept = window.localStorage.getItem('bsmdept')
      this.compid = window.localStorage.getItem('bsmcompid')
      this.summaps[0].priunite = this.dept === 'Sales' ? '万元' : '款数'
      this.summaps[2].priunite = this.dept === 'Sales' ? '万元' : '款数'

      this.axios({
        // params: {
        //   compid: this.compid
        // },
        method: 'post',
        url:this.requestUrl+ '/admin.php/Bigsreen/propartsum?compid='+this.compid
      })
        .then((Response) => {
          var clio = JSON.parse(Response.data)
          // console.log(clio)
          this.summaps[0].pcs = clio[0].PCS

          this.summaps[0].sumpri = this.dept === 'Sales' ? (clio[0].sumprice / 1).toFixed(1) : (clio[0].PG / 1).toFixed(1)

          this.summaps[2].pcs = clio[1].PCS
          this.summaps[2].sumpri = this.dept === 'Sales' ? (clio[1].sumprice / 1).toFixed(1) : (clio[1].PG / 1).toFixed(1)
          if(this.dept === 'PMD')
          {
            this.summaps[4].title='本月应出货'
            this.summaps[4].pcs= clio[2].PCS
            this.summaps[4].sumpri= clio[2].PG
          this.summaps[4].pcsunite='件'
          this.summaps[4].priunite='款'
          // pcsuniteWidth: '24px',
          this.summaps[4].pcspretxt=''
          this.summaps[4].pripretxt=''
          // pcsadd: 0,
          // priadd: 0
          }
        })
        .catch(function (error) {
          console.log(error +" Statistics")
        })
    }
  },
  beforeDestroy () {
    this.$EventBus.$off('SalesumMMOrder')
    this.$eventBus.$off('Salesumwokhours')
    this.$eventBus.$off('SalesumOderShip')
    clearInterval(this.requestTimer)
  },
  mounted () {
    this.requestTimer = setInterval(() => {
      this.getsumaa()
    }, config.refreshTime.statistic)
    this.$eventBus.$on('SalesumMMOrder', (sumpri) => {
      let aa = []
      aa.push(sumpri[1].toFixed(0))
      this.summaps[1].pcs = sumpri[0] // [(sumpri/1).toFixed(0)/1];
      this.summaps[1].sumpri = sumpri[1]
    })
    // 来自近13个月采购数量统计的数据 给 2 4 5赋值
    this.$eventBus.$on('SalesumOderShip', (obj) => {
      this.summaps[1].pcs = obj['two']['pcs']
      this.summaps[1].priunite = obj['two']['priunite']
      this.summaps[1].sumpri = obj['two']['sumpri']

      this.summaps[3].pcs = obj['four']['pcs']
      this.summaps[3].priunite = obj['four']['priunite']
      this.summaps[3].sumpri = obj['four']['sumpri']

      if(this.dept === 'Sales')
      {
      this.summaps[4].pcs = obj['five']['pcs']
      this.summaps[4].pripretxt = obj['five']['pripretxt']
      this.summaps[4].sumpri = obj['five']['sumpri']
      }

      // console.log(this.summaps);
    })

    this.$eventBus.$on('Salesumpurinfo', (ss) => {
      this.summaps[5].sumpri = this.dept === 'Sales' ? ss[0]['price'] : ss[0]['pg'] // [(sumpri/1).toFixed(0)/1];
      this.summaps[5].pcs = ss[0]['pcs']
      this.summaps[5].priunite = this.dept === 'Sales' ? '万元' : '款数'

      this.summaps[6].sumpri = this.dept === 'Sales' ? ss[1]['price'] : ss[1]['g'] // [(sumpri/1).toFixed(0)/1];
      this.summaps[6].pcs = ss[1]['pcs']
      this.summaps[6].priunite = this.dept === 'Sales' ? '万元' : '款数'

      this.summaps[7].sumpri = this.dept === 'Sales' ? ss[0]['rate'] : ss[0]['g']// [(sumpri/1).toFixed(0)/1];
      this.summaps[7].pripretxt = this.dept === 'Sales' ? '金额达成率' : '款数达成率'
      // this.summaps[7].pripretxt = ss[0]['pripretxt'] // [(sumpri/1).toFixed(0)/1];
      // this.summaps[7].priunite = ss[0]['priunite'] // [(sumpri/1).toFixed(0)/1];
      this.summaps[7].pcs = ss[1]['rate']
    })
    this.$eventBus.$on('Salesumwokhours', (ss) => {
      // console.log("this.maps.count="+this.maps.length)
      this.summaps[8].pcs = ss[0]['newwks'] // [(sumpri/1).toFixed(0)/1];
      this.summaps[8].sumpri = ss[0]['okwks']

      // this.maps[8].unit="h新增";
      // this.maps[8].unita="h完成";
    })
  }
}
</script>

<style scoped lang="less">
.statistics {
  width: 1845px;
  height: 173px;
  margin: 0 auto;
  background-image: url('../../../assets/images/bigscreenSales/statistics.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .statistics-box {
    justify-content: space-evenly;
    align-items: center;
    height: 173px;
  }
  .left {
    margin-right: 12px;
    .title {
      height: 26px;
      margin-bottom: 12px;
      padding-right: 18px;
      font-family: 'PingFang SC';
      font-style: normal;
      text-align: center;
      font-weight: 500;
      font-size: 20px;
      line-height: 26px;
      background: linear-gradient(180deg, #2dcdff 37.5%, #2ffff4 100%), #2dcdff;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      flex: none;
      order: 0;
      flex-grow: 0;
    }

    .digital-flopa {
      align-items: baseline;
      justify-content: space-between;
      position: relative;
      .pcspre {
        height: 24px;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
        color: #80dbf8;
      }
      .pri {
        height: 45px;
        font-family: 'Bebas';
        font-style: normal;
        font-weight: 400;
        font-size: 28px;
        line-height: 45px;
        color: #ffffff;
        margin: 0 8px;
        text-align: right;
        flex: 1;
      }

      .unit {
        height: 24px;
        width: 32px;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
        color: #c6d1db;
        text-align: left;
      }
      .unit-en {
        font-size: 24px;
      }
      .trend {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        img{
          width: 12px;
          height: 14px;
        }
      }
    }
  }
  .right {
    img {
      width: 3px;
      height: 101px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreenSales/components/Statistics.vue